module.exports = __webpack_public_path__ + "media/src/images/icons/dash-116f802a292fe4abaf1b16464dcfb0c0.svg";